import { render, staticRenderFns } from "./SeguimientoIndicadores.vue?vue&type=template&id=054a1018&"
import script from "./SeguimientoIndicadores.vue?vue&type=script&lang=js&"
export * from "./SeguimientoIndicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports